/**
 * Тексты soft paywall «Замена блюда» (A/B и локализация — отдельно).
 */

export const REPLACE_MEAL_PAYWALL_TITLE = "Ребёнок не будет это есть? 🙈";

/** Первая строка подзаголовка (контекст тарифа). */
export const REPLACE_MEAL_PAYWALL_SUBTITLE_LEAD = "Быстрая замена блюда доступна в полной версии";

/** Вторая строка подзаголовка (обещание). */
export const REPLACE_MEAL_PAYWALL_SUBTITLE_TAGLINE = "Замените блюдо за секунду — без стресса";

export const REPLACE_MEAL_PAYWALL_CTA_TRIAL = "Попробовать бесплатно 3 дня";

export const REPLACE_MEAL_PAYWALL_CTA_BACK = "Назад";

export const REPLACE_MEAL_PAYWALL_CTA_PRICING = "Чем отличается полная версия";
